export default function WalletIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M14.082 4.66667V3.33333H3.41536V12.6667H14.082V11.3333H8.7487C8.57189 11.3333 8.40232 11.2631 8.27729 11.1381C8.15227 11.013 8.08203 10.8435 8.08203 10.6667V5.33333C8.08203 5.15652 8.15227 4.98695 8.27729 4.86193C8.40232 4.7369 8.57189 4.66667 8.7487 4.66667H14.082ZM2.7487 2H14.7487C14.9255 2 15.0951 2.07024 15.2201 2.19526C15.3451 2.32029 15.4154 2.48986 15.4154 2.66667V13.3333C15.4154 13.5101 15.3451 13.6797 15.2201 13.8047C15.0951 13.9298 14.9255 14 14.7487 14H2.7487C2.57189 14 2.40232 13.9298 2.27729 13.8047C2.15227 13.6797 2.08203 13.5101 2.08203 13.3333V2.66667C2.08203 2.48986 2.15227 2.32029 2.27729 2.19526C2.40232 2.07024 2.57189 2 2.7487 2ZM9.41536 6V10H14.082V6H9.41536ZM10.7487 7.33333H12.7487V8.66667H10.7487V7.33333Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
